import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { LoginService } from "./../_services/login.service";

@Component({
    selector: 'expiry-link',
    templateUrl: './expirylink.component.html',
    styleUrls: ['./expirylink.component.scss'],
    standalone: false
})
export class ExpiryComponent implements OnInit {

  successMessage: string = '';
  errorMessage: string = '';
  pwd_reset_link_form: UntypedFormGroup;

  constructor(private _loginservice: LoginService, public fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.pwd_reset_link_form = this.fb.group({
      emailid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
    })
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  

  requestlink(){
    if(this.pwd_reset_link_form.valid){
      let data ={
        "loginemail": this.pwd_reset_link_form.value.emailid
      }
  
      this._loginservice.forgetpassword(data).subscribe((res:any)=>{
        if(res.status == 'Mail sent'){
          this.toastmessage("We have sent password reset link to your email address","success")
        }else if(res.message == 'Email id not found'){
          this.toastmessage("Email id not found","error")
        }else{
          this.toastmessage("Email id not found","error")
        }
      })
    }else {
      this.validateAllFormFields(this.pwd_reset_link_form)
    }
  }
}